import {
  ROOT_CONTEXT,
  SpanContext,
  defaultTextMapSetter,
  trace,
} from '@opentelemetry/api';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { TRACEPARENT_HEADER } from './traceparent-header.constant';

const propagator = new W3CTraceContextPropagator();

export function serializeSpanContext(spanContext: SpanContext): string {
  const carrier: Record<string, string> = {};
  const contextWithSpan = trace.setSpanContext(ROOT_CONTEXT, spanContext);

  propagator.inject(contextWithSpan, carrier, defaultTextMapSetter);

  const traceparent = carrier[TRACEPARENT_HEADER];

  if (!traceparent) {
    throw new Error('OpenTelemetry did not serialize a traceparent header.');
  }

  return traceparent;
}
